export default __webpack_public_path__ + "static/media/BED.b80440c2.webp";